export const featureIds = {
  tasks: 'hu7PAijt4d1q',
  logRetention: '6Al86Kq5IHQw',
  runnerSize: 'yfcrnbqfasxe',
  apps: 'uvPiJWHi43QZ',
  workflows: 'KoBju7ntUQQR',
  jobsScreen: 'ynvpwzrxmzyl'
};
